'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _themeable = require('../themeable');

var _themeable2 = _interopRequireDefault(_themeable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** General purpose menu item */
var MenuItem = function (_Component) {
  _inherits(MenuItem, _Component);

  function MenuItem() {
    _classCallCheck(this, MenuItem);

    var _this = _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call(this));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(MenuItem, [{
    key: 'handleClick',
    value: function handleClick(event) {
      var _props = this.props,
          closeMenu = _props.closeMenu,
          onClick = _props.onClick;


      if (closeMenu) {
        closeMenu(event);
      }

      onClick(event);
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon() {
      var _props2 = this.props,
          icon = _props2.icon,
          active = _props2.active,
          color = _props2.color;


      if (active) {
        return _react2.default.cloneElement(icon, { color: color });
      }

      return icon;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          icon = _props3.icon,
          text = _props3.text,
          style = _props3.style,
          textStyle = _props3.textStyle,
          iconStyle = _props3.iconStyle,
          active = _props3.active,
          closeMenu = _props3.closeMenu,
          onClick = _props3.onClick,
          rightButton = _props3.rightButton,
          buttonStyle = _props3.buttonStyle,
          color = _props3.color,
          activeStyle = _props3.activeStyle,
          custom = _objectWithoutProperties(_props3, ['icon', 'text', 'style', 'textStyle', 'iconStyle', 'active', 'closeMenu', 'onClick', 'rightButton', 'buttonStyle', 'color', 'activeStyle']);

      return _react2.default.createElement(
        'section',
        _extends({
          style: _getStyles2.default.root(color, icon, active, rightButton, style, activeStyle),
          onClick: this.handleClick
        }, custom),
        icon ? _react2.default.createElement(
          'div',
          { style: _getStyles2.default.icon(iconStyle) },
          this.renderIcon()
        ) : null,
        _react2.default.createElement(
          'p',
          { style: _getStyles2.default.text(textStyle) },
          text
        ),
        rightButton ? _react2.default.createElement(
          'div',
          { style: _getStyles2.default.rightButton(buttonStyle) },
          rightButton
        ) : null
      );
    }
  }]);

  return MenuItem;
}(_react.Component);

MenuItem.displayName = 'MenuItem';
MenuItem.propTypes = {
  /** The item's icon */
  icon: _propTypes2.default.node,
  /** The item's label */
  text: _propTypes2.default.node.isRequired,
  /** MenuItem active */
  active: _propTypes2.default.bool,
  /**
   * Callback fired when MenuItem is clicked
   *
   * function(event: object) => void
   */
  onClick: _propTypes2.default.func.isRequired,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the input element */
  textStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the icon element */
  iconStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback fired when the MenuItem closes a Menu/IconMenu
   *
   * function(event: object) => void
   */
  closeMenu: _propTypes2.default.func,
  /** Right-hand side placed button */
  rightButton: _propTypes2.default.node,
  /** Override the styles of the right button element */
  buttonStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override style applied when the MenuItem is active */
  activeStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  color: _propTypes2.default.string.isRequired
};
MenuItem.defaultProps = {
  icon: null,
  active: false,
  style: {},
  textStyle: {},
  iconStyle: {},
  buttonStyle: {},
  closeMenu: null,
  rightButton: null,
  activeStyle: {}
};
MenuItem.contextTypes = {
  color: _propTypes2.default.string
};


var enhance = (0, _compose2.default)((0, _themeable2.default)(), _radium2.default);

exports.default = enhance(MenuItem);
module.exports = exports.default;